<template>

    <div class="changepassword">
        <h2 class="mb-3">{{ $t('Change Password') }}</h2>

        
        <div v-if="isShow">
            <bootstrap-alert 
                :variant="response.variant" 
                :msg="response.message" 
                :errorMsg="response.errmsg"
            />
        </div>

        
        <form  class="w-150" @submit.prevent="onSubmit" novalidate>
            <div class="row">

                <div v-if="loading" class="loading"></div>

                <div class="col-md-7 mb-3">
                
                    <div class="matches" v-if='notSamePasswords'>
                        <p class="text-danger">{{ $t("Passwords don't match.") }}</p>
                    </div>
                    <div class="matches" v-if="showError">
                        <p class="text-danger">{{ $t(this.errorMessage) }}</p>
                    </div>
                    
                    <b-form-group :label="$t('Old Password')" label-for="newpassword"  class="form-group-required">
                        <b-form-input
                            id="oldpassword"
                            v-model="form.oldpassword"
                            type="password"
                            maxlength="25"
                            :class='{valid:passwordValidation.valid}'
                            class="form-control input-field"
                            key="oldpassword"
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group :label="$t('New Password')" label-for="newpassword" class="form-group-required">
                        <b-form-input
                            id="newpassword"
                            :class='{valid:passwordValidation.valid}'
                            v-model="form.newpassword"
                            type="password"
                            maxlength="25"
                            class="form-control input-field"
                            key="newpassword"
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group :label="$t('Confirm new password')" label-for="confirm-newpassword" class="form-group-required">
                        <b-form-input
                            id="confirm-newpassword"
                            v-model.lazy='form.confirmnewpassword'
                            type="password"
                            maxlength="25"
                            class="form-control input-field"
                            key="confirm-newpassword"
                        ></b-form-input>
                    </b-form-group>

                    <b-button 
                        type="submit" 
                        class="btn btn-primary d-block w-100 login-button bg-black"
                        :disabled="passwordsFilled && !notSamePasswords && passwordValidation.valid ? false : true"
                        >
                        {{ $t('Submit') }}
                    </b-button>
                </div>

                <div class="col-md-5">
                    <div v-if='passwordValidation.errors.length > 0 && !form.submitted' class="alert alert-info">
                        <strong>{{ $t('Hints') }}</strong>
                        <ul>
                            <li :key="error" v-for='error in passwordValidation.errors'>
                                {{ $t(error) }}
                            </li>
                        </ul>
                    </div>
                    
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
    data() {
        return {
            form: {
                oldpassword: '',
                newpassword: '',
                confirmnewpassword: '',
                submitted: false
            },
            rules: [
				{ message: "One lowercase letter required.", regex:/[a-z]+/ },
				{ message: "One uppercase letter required.",  regex:/[A-Z]+/ },
				{ message: "Special characters.",  regex:/[ !"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]/ },
				{ message: "8 characters minimum.", regex:/.{8,}/ },
				{ message: "One number required.", regex:/[0-9]+/ }
            ],
            showError: false,
            errorMessage: ''
        }
    },
    computed: {
        ...mapGetters('changepassword', ['response', 'isShow', 'loading']),
        ...mapGetters('app', ['currentLang']),
        notSamePasswords () {
			if (this.passwordsFilled) {
				return (this.form.newpassword !== this.form.confirmnewpassword)
			} else {
				return false
			}
		},
		passwordsFilled () {
			return (this.form.newpassword !== '' && this.form.confirmnewpassword !== '')
		},
		passwordValidation () {

            let errors = [];
            // this.setIsShow(false);
			for (let condition of this.rules) {
				if (!condition.regex.test(this.form.newpassword) || !condition.regex.test(this.form.oldpassword)) {
                    errors.push(condition.message)
                }
            }
            
			if (errors.length === 0) {
				return { valid: true, errors }
			} else {
				return { valid: false, errors }
			}
		}
    },
    created() {
        this.resetError();
    },
    methods: {
        ...mapActions('changepassword', ['setIsShow', 'changePassword']),
        ...mapActions('editprofile', ['resetError']),
        ...mapActions('auth', ['clearUserSessionData']),
        onSubmit() {           
            this.changePassword({
                oldpassword: this.form.oldpassword, 
                password: this.form.confirmnewpassword,
                lang: this.currentLang
            })
            .then((response) => {

                this.showError = false
                this.setIsShow(false);

                this.form.oldpassword = '';
                this.form.newpassword= '';
                this.form.confirmnewpassword= '';
                
                this.clearUserSessionData()
                this.flash(this.$t('Password Changed Successfully, please re-login to access your account'), 'success',{
                    timeout: 10000
                })
                this.$router.push({ 
                        path: '/login', params: {  }, replace: true
                    }).catch(err => {});
            })
            .catch(error => {
                if(error.response.data.message)
                {
                    this.errorMessage = error.response.data.errors.join()
                    this.showError = true
                } else {
                    this.showError = false
                    this.$router.push({ 
                        path: '/login', params: {  }, replace: true
                    }).catch(err => {});
                }
            });
        }
    },
    destroyed(){
        // this.setIsShow(false)
    }
};
</script>